export var environmentProd = {
    FRED: "THIS IS A DUMMY VALUE",
    I_DONT_WANT_THIS_CAR: "956477",
    FOMO_EXPERIMENT_ID: "1101365",
    REQUEST_CALLBACK_EXPERIMENT_ID: "1071651",
    SEARCH_MULTIPLE_IMAGES_EXPERIMENT_ID: "1107133",
    CLIENT_PROD_TEST: "1110683",
    NEXT_BEST_ACTION_EXPERIMENT_ID: "1115840",
    // SSR Enabled Activities
    SSR_PROD_TEST: "1115015",
    // Activity Location IDs
    HOMEPAGE_SSR_TEST: "homepage-aa-test-2"
};
